
export default {
    namespaced: true,
    state: {
      serverJDs: [],
      recommendedJDs: [],
      filteredJDs: [],
      serverPage: 1,
      loading: false,
      // jdSearch: '',
      // searchType: 'all',
      serverTotalPages: 1,
      isSubmitting: false,
  
      userBasedSearchConditions: {
        jdSearch: '',
        searchType: 'all',
      },
  
      serverSearchConditions: {
        jdSearch: '',
        searchType: 'all',
      },
  
      preservedState: {
        scrollPosition: 0,
      },
  
    },
    getters: {
      getTempRecommendedJds: (state) => state.tempRecommendedJDs,
      getPreservedState: (state) => state.preservedState,
      getTempServerJds: (state) => state.tempServerJDs,
      getServerPage: (state) => state.serverPage,
      getServerTotalPages: (state) => state.serverTotalPages,
      getJdSearch: (state) => state.jdSearch,
      getSearchType: (state) => state.searchType,
      displayedItems: (state) => {
          if (state.userBasedMatching) {
            const start = (state.serverPage - 1) * state.pageSize;
            const end = start + state.pageSize;
            return state.recommendedJDs.slice(start, end);
          }
          return state.serverJDs;
        }
    },
  
    mutations: {
      setPreservedState(state, payload) {
        state.preservedState = payload;
      },
      setServerJds(state, payload) {
        state.serverJDs = payload;
      },
      setRecommendedJds(state, payload) {
        state.recommendedJDs = payload;
      },
      setFilteredJds(state, payload) {
        state.filteredJDs = payload;
      },
      setAllJds(state, payload) {
        state.allJDs = payload;
      },
      setRecommendedJds(state, payload) {
        state.recommendedJDs = payload;
      },
      setUserBasedSearchConditions(state, { jdSearch, searchType}) {
        state.userBasedSearchConditions = { jdSearch, searchType };
      },
      setServerSearchConditions(state, { jdSearch, searchType}) {
        state.serverSearchConditions = { jdSearch, searchType };
      },
      setServerPage(state, payload) {
        state.serverPage = payload;
      },
      setServerTotalPages(state, payload) {
        state.serverTotalPages = payload;
      },
      setPagination(state, payload) {
          state.serverPage = payload.page;
          state.totalPages = payload.totalPages;
      },
      setJdSearch(state, query) {
          state.jdSearch = query;
      },
      setSearchType(state, type) {
          state.searchType = type;
      },
      setLoading(state, loading) {
        state.loading = loading;
      },
      setIsSubmitting(state, payload) {
          state.isSubmitting = payload;
      },
      setTempRecommendedJds(state, payload) {
          state.tempRecommendedJDs = payload;
      },
      setTempServerJds(state, payload) {
          state.tempServerJDs = payload;
      },
      clearProfileJDDatas(state){
        state.serverJDs = [];
        state.tempServerJDs = [];
        state.filteredJDs = [];
        state.tempRecommendedJDs = [];
        state.recommendedJDs = [];
        state.serverPage = 1;
        state.userBasedSearchConditions = {
          jdSearch: '',
          searchType: 'all',
        };
        state.serverSearchConditions = {
          jdSearch: '',
          searchType: 'all',
        };
      }
      
    },
  };